import { request, METHOD, removeAuthorization } from "@/utils/request";
import axios from "axios";
import Cookie from "js-cookie";
var MANAGER_URL = process.env.VUE_APP_API_BASE_URL;
var config = {
  headers: {
    "Content-Type": "application/josn;charset=utf-8;",
    /* "x-auth-token": Cookie.get('x-auth-token') || "888", */
    // "x-auth-token": "888",
    "x-sign-token": "888"
  }
};
export function designPublicData(data) {
  return request("".concat(MANAGER_URL, "/design/publicData"), METHOD.GET, data);
}
export function designBulletinBoardInfo(data) {
  return request("".concat(MANAGER_URL, "/design/bulletinBoardInfo"), METHOD.GET, data);
}
export function designNews(data) {
  return request("".concat(MANAGER_URL, "/news"), METHOD.GET, data);
}
export function designGetProductList(data) {
  return request("".concat(MANAGER_URL, "/design/page/info"), METHOD.GET, data);
}
export function designSave(data) {
  return request("".concat(MANAGER_URL, "/design/save"), METHOD.POST, data);
}
export function designPublish(data) {
  return request("".concat(MANAGER_URL, "/design/publish"), METHOD.POST);
}
export function designSearchProduct(data) {
  return request("".concat(MANAGER_URL, "/design/product/list"), METHOD.GET, data);
}
export function clientNameList(data) {
  return request("".concat(MANAGER_URL, "/design/pc/cart/category/nameList"), METHOD.GET, data, config);
}
export function clientKeyWordList(data) {
  return request("".concat(MANAGER_URL, "/design/common/keyWord/list"), METHOD.GET, data, config);
}
export function recommendProduct(data) {
  return request("".concat(MANAGER_URL, "/design/page/recommendProduct"), METHOD.GET, data, config);
}

/* export function clientPublicData(data) {
 *   return request(
 *     `${BASE_URL}/common/customer/publicData`,
 *     METHOD.GET,
 *     data,
 *     config
 *   );
 * } */